import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  fieldWrapper: {
    padding: 5,
    border: '1px solid rgba(224, 224, 224, 1)',
  },
  multipleSelectWrapper: {
    padding: 0,
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  textField: {
    width: '100%',
  },
  input: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    marginLeft: 7,
    marginRight: 20,
  },
  numberInput: {
    maxWidth: 50,
  },
  multiSelect: {
    width: '100%',
    border: 0,
    padding: 3,
  },
  multiSelectOutput: {
    minWidth: 0,
    maxWidth: '100%',
  },
  multiSelectLabel: {
    fontSize: 14,
    color: theme.custom.darkBlue,
  },
  mt20: {
    marginTop: 20,
  },
  filtersBar: {
    padding: 10,
  },
  resetBtn: {
    padding: 12,
    fontSize: 14,
    lineHeight: 1,
    background: theme.custom.lightBlue,
  },
  paginationWrapper: {
    marginTop: 20,
  },
  overflow: {
    overflowX: 'auto',
  },
  textFieldRoot: {
    width: '100%',
  },
}));
